import { useMemo } from "react";

interface UseOtpStylesProps {
  disabled?: boolean;
  error?: boolean;
}

interface OtpStyles {
  inputClassName: string;
}

export const useOtpStyles = ({
  disabled = false,
  error = false,
}: UseOtpStylesProps): OtpStyles => {
  const inputClassName = useMemo(() => {
    const baseClasses =
      "w-full aspect-square border rounded-lg text-[1em] font-medium text-center outline-none transition-all duration-150 ease-in-out focus:ring-0";

    if (disabled) {
      return `${baseClasses} border-tertiary bg-secondary text-disabled cursor-not-allowed`;
    }

    if (error) {
      return `${baseClasses} border-danger bg-primary text-darkest focus-visible:border-danger focus-visible:shadow-focus`;
    }

    return `${baseClasses} border-primary bg-primary text-darkest focus-visible:border-focus focus-visible:shadow-focus`;
  }, [disabled, error]);

  return {
    inputClassName,
  };
};
